<app-title-bar [title]='"Vista General"' [icon]="'zoom_in_map'"></app-title-bar>
<div id="overviewDiv" class="overview">
    <div id="extentDiv"></div>